/* Dawbu wishlist (mobile): items saved on this device only (localStorage).
   Filled by the swipe game ("swipe right"), shown from the heart icon in the
   header, and each item can be moved to the cart.

   window.DawbuWishlist = { items(), has(id), add(item), remove(id), open(), close() }
   item = { id: variantId, handle, title, price: cents, image, url }
   Fires `dw:wishlist-change` on document whenever the list changes. */
(() => {
  if (window.DawbuWishlist) return;

  const KEY = 'dw_wishlist_v1';
  // store currency (USD on Mizozu US), not a hard-coded ₹
  const CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(CUR === 'INR' ? 'en-IN' : 'en-US', { style: 'currency', currency: CUR, minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0);
    }
  };

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  };
  let list = read();

  const save = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('dw:wishlist-change', { detail: { items: list.slice() } }));
  };

  const api = {
    items: () => list.slice(),
    has: (id) => list.some((i) => String(i.id) === String(id)),
    add(item) {
      if (!item || !item.id || api.has(item.id)) return;
      list.unshift(item);
      save();
      bump();
    },
    remove(id) {
      list = list.filter((i) => String(i.id) !== String(id));
      save();
    },
    open,
    close,
  };
  window.DawbuWishlist = api;

  // Another tab changed the list
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) {
      list = read();
      render();
    }
  });

  let panel, listEl, countEls, toastTimer;

  function bump() {
    document.querySelectorAll('.dw-wish-btn').forEach((btn) => {
      btn.classList.remove('dw-wish-btn--bump');
      void btn.offsetWidth;
      btn.classList.add('dw-wish-btn--bump');
    });
  }

  function toast(msg) {
    let t = document.querySelector('.dw-wish-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'dw-wish-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2200);
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  function render() {
    if (!panel) return;
    countEls.forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
    panel.querySelector('[data-dw-wish-total]').textContent = list.length;
    panel.querySelector('[data-dw-wish-all]').hidden = list.length < 2;
    panel.querySelector('[data-dw-wish-empty]').hidden = list.length > 0;
    listEl.innerHTML = list
      .map(
        (i) => `
      <li class="dw-wish__item" data-id="${escapeHtml(i.id)}">
        <a class="dw-wish__img" href="${escapeHtml(i.url)}"><img src="${escapeHtml(i.image)}" alt="" loading="lazy" width="64" height="64"></a>
        <div class="dw-wish__info">
          <a class="dw-wish__title" href="${escapeHtml(i.url)}">${escapeHtml(String(i.title || '').replace(/^Miniature\s+/i, '').replace(/\s*Assorted.*$/i, '').replace(/\s*\(\d*\s*pcs?\)\s*$/i, ''))}</a>
          <span class="dw-wish__price">${money(i.price)}</span>
          <div class="dw-wish__row">
            <span class="dw-wish__qty">
              <button type="button" data-dw-wish-step="-1" aria-label="One less">−</button>
              <span data-dw-wish-n>${i.qty || 1}</span>
              <button type="button" data-dw-wish-step="1" aria-label="One more">+</button>
            </span>
            <button type="button" class="dw-wish__add" data-dw-wish-add="${escapeHtml(i.id)}">Add to cart</button>
          </div>
        </div>
        <button type="button" class="dw-wish__remove" data-dw-wish-remove="${escapeHtml(i.id)}" aria-label="Remove ${escapeHtml(i.title)}">✕</button>
      </li>`
      )
      .join('');
  }

  async function addToCart(ids, btn) {
    const label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    try {
      const res = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.flatMap((id) => {
            const it = list.find((x) => String(x.id) === String(id)) || {};
            const q = it.qty || 1;
            // a saved bundle (hw-bundles.js) adds each of its pieces
            if (Array.isArray(it.ids)) return it.ids.map((v) => ({ id: Number(v), quantity: q, properties: { _bundle: it.title || 'Bundle' } }));
            return [{ id: Number(id), quantity: q }];
          }),
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');

      ids.forEach((id) => (list = list.filter((i) => String(i.id) !== String(id))));
      save();
      toast(ids.length > 1 ? `${ids.length} items added to cart ✓` : 'Added to cart ✓');

      // Refresh the cart icon, drawer and dock the same way the theme does
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        const doc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
        const inner = doc.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const cart = await (await fetch('/cart.js')).json();
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dw-wishlist', cartData: cart });
        }
      } catch (e) {}
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        close();
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: ids[0], sections: data.sections });
      }
    } catch (e) {
      toast(e.message || 'Could not add to cart');
    } finally {
      if (btn && btn.isConnected) {
        btn.disabled = false;
        btn.textContent = label;
      }
    }
  }

  function open() {
    if (!panel) return;
    render();
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-open'));
    document.body.classList.add('dw-wish-open');
  }

  function close() {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    document.body.classList.remove('dw-wish-open');
    setTimeout(() => (panel.hidden = true), 250);
  }

  function init() {
    panel = document.getElementById('DwWishlist');
    if (!panel) return;
    // The sticky header can be transformed, which would trap a fixed panel
    document.body.appendChild(panel);
    listEl = panel.querySelector('[data-dw-wish-list]');
    countEls = document.querySelectorAll('[data-dw-wish-count]');

    document.querySelectorAll('.dw-wish-btn').forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        open();
      })
    );
    panel.addEventListener('click', (e) => {
      const t = e.target;
      if (t.closest('[data-dw-wish-close]') || t === panel) return close();
      const step = t.closest('[data-dw-wish-step]');
      if (step) {
        const li = step.closest('[data-id]');
        const item = list.find((x) => String(x.id) === li.dataset.id);
        if (!item) return;
        item.qty = Math.min(99, Math.max(1, (item.qty || 1) + Number(step.dataset.dwWishStep)));
        li.querySelector('[data-dw-wish-n]').textContent = item.qty;
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
        return;
      }
      const add = t.closest('[data-dw-wish-add]');
      if (add) return addToCart([add.dataset.dwWishAdd], add);
      const rm = t.closest('[data-dw-wish-remove]');
      if (rm) return api.remove(rm.dataset.dwWishRemove);
      const all = t.closest('[data-dw-wish-all]');
      if (all) return addToCart(list.map((i) => i.id), all);
    });
    document.addEventListener('keydown', (e) => e.key === 'Escape' && close());
    document.addEventListener('dw:wishlist-change', render);
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
